import { useTranslation } from 'react-i18next';

import { Text } from '@fly/core';

export type NoResultProps = {
  /** Stable hook for e2e (deployments vs environments grid). */
  testId?: string;
};

export function NoResult({ testId }: NoResultProps) {
  const { t } = useTranslation();
  return (
    <div
      className='flex h-full min-h-[130px] w-full flex-col items-center justify-center gap-fly-1'
      {...(testId ? { 'data-testid': testId } : {})}
    >
      <Text size='4' color='neutral' highContrast className='font-semibold'>
        {t(
          'app.dashboard.runtime_environments.environments.no_data_found_filter.title',
          {
            defaultValue: 'No Results',
          }
        )}
      </Text>
      <Text size='2' color='neutral'>
        {t(
          'app.dashboard.runtime_environments.environments.no_data_found_filter.subtitle',
          {
            defaultValue: 'Remove or adjust your search filters',
          }
        )}
      </Text>
    </div>
  );
}
